import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import ContentLoader from 'react-content-loader';
import { withRouter } from 'react-router-dom';
import { Select, MenuItem, CircularProgress, withTheme } from '@material-ui/core';
import { FormattedMessage, injectIntl } from 'react-intl';
import Geosuggest from 'react-geosuggest';
import { cookies, getCookies } from '../../utils/getToken';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { GOOGLE_MAP_KEY, SERVER_URL, ROLE_CUSTOMER } from '../../utils/config/constants';
import Modal from '@material-ui/core/Modal';
import { Fade, DialogContent, Dialog } from '@material-ui/core';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { compose } from 'redux';
import * as actions from '../../actions';
import { NotificationManager } from 'react-notifications';
import NewServiceSuggestionDialog from '../Dialogs/NewServiceSuggestionDialog';
import { Clear, Add, Remove, GpsFixed, LocationOn, ArrowForward } from '@material-ui/icons';

let isMounted = false;
let loading = false;

var selectedIndex = 0

var serviceData = []
var addedTask = null

class HomeCaroselParallax extends React.Component {
    constructor(props) {
        super(props);
        var windowScrollTop = window.pageYOffset / 3;
        this.state = {
            transform: 'translate3d(0,' + windowScrollTop + 'px,0)',
            keyword: '',
            city: '',
            headingTitle: '',
            category: 'all',
            showModal: false,
            categoryData: [],
            dropCategoryData: [],
            categoryServiceData: [],
            newcategoryServiceData: [],
            catIndex: 0,
            showServiceDialog: false,
            addedTaskValue: 0,
            serviceData: [],
            x: 0,
            selectedServiceId: "",
            service_type: "",
            newServiceDialog: false,
            noDataMessage: "",
            mastercategory_id: "",
            searchLoader: false,
            phoneError: "",
            error: "",
            email: '',
            password: '',
            playerId: '',
            countryCode: '1',
            phone: '',
            hideLogin: true,
            hideGetOtp: false,
            is_otp: true,
            timer: 10,
            accountType: "420",
            typeError: "",
            showChangePhone: false,
            loaderButton: false,
            nameError: '',
            name: '',
            refferError: "",
            reffer: "",
            showBookButton: false,
            showSuggestionButton: true
        };
        this.resetTransform = this.resetTransform.bind(this);
    }
    componentDidUpdate() {
        if (this.state.timer === 0) {
            clearInterval(this.time)
        }

    }
    componentDidMount() {
        isMounted = true;
        this.getData();
        this.getCategoryData(this.state.catIndex);
    }
    componentWillUpdate(prevProps, prevState) {
        if (prevProps.banners)
            if (prevProps.banners.length != this.props.banners.length) {
                loading = true;
            }
    }
    getData = () => {
        if (isMounted) {
            var windowScrollTop = window.pageYOffset / 3;
            this.setState({
                transform: 'translate3d(0,' + windowScrollTop + 'px,0)'
            });
            window.addEventListener('scroll', this.resetTransform);
        }
    };


    getSearchData = (catIndex) => {
        axios({
            method: 'get',
            url: `${SERVER_URL}/mastercategory/searchlist?search=${this.state.keyword}&city=${this.state.city}&long=${cookies.get('longitude') ? cookies.get('longitude') : ''}&lat=${cookies.get('latitude') ? cookies.get('latitude') : ''}`,
        }).then(resJson => {
            console.log("search categorydata:::::", resJson)
            if (resJson.data.status == "OK" && resJson.data.data.length > 0) {
                this.setState({
                    categoryData: resJson.data.data,
                    categoryServiceData: resJson.data.data[catIndex].categories,
                    newcategoryServiceData: JSON.parse(JSON.stringify(resJson.data.data[catIndex].categories)),
                    noDataMessage: resJson.data.message,
                    showModal: true,
                    searchLoader: false
                })
            } else {
                this.setState({
                    showModal: true,
                    searchLoader: false
                })
            }
        })

    }
    getMainSearchData = (catIndex) => {
        console.log("all popup", catIndex)
        if (this.statmastercategory_id == "all") {

            this.setState({
                mastercategory_id: ""
            }, () => { this.getSearchData(catIndex) })
        } else {
            console.log("mt")
            this.getSearchData(catIndex)

        }
    }


    getCategoryData = (catIndex) => {
        var authToken = getCookies();
        console.log("Tokennnnnnn:::::", authToken)
        axios({
            method: 'get',
            url: `${SERVER_URL}/mastercategory/newlist`,

            headers: { 'x-auth-token': authToken }
        }).then(resJson => {

            console.log("CategoryData:::", resJson)
            this.setState({
                categoryData: resJson.data.data,
                dropCategoryData: resJson.data.data,
                categoryServiceData: resJson.data.data.length > 0 && resJson.data.data[catIndex].categories.length > 0
                    ? resJson.data.data[catIndex].categories : [],
                newcategoryServiceData: resJson.data.data.length > 0 && resJson.data.data[catIndex].categories.length > 0
                    ? JSON.parse(JSON.stringify(resJson.data.data[catIndex].categories)) : []
            })
        })
    }

    fastSubCat = (index) => {
        console.log("sjdbd", this.state.headingTitle = this.state.categoryData[index].categories[0].mastercategory.name)

        this.state.headingTitle = this.state.categoryData[index].categories[0].mastercategory.name;

        this.setState({
            newcategoryServiceData: JSON.parse(JSON.stringify(this.state.categoryData[index].categories))
        })
    }

    fast = (index) => {

        selectedIndex = index
        this.fastSubCat(index)
    }

    handleChangeSubCategory = (catIndex) => {
        console.log("MasterCategoryId:::,", this.state.mastercategory_id)
        selectedIndex = catIndex
    }

    componentWillUnmount() {
        clearInterval(this.time)
        isMounted = false;
        window.removeEventListener('scroll', this.resetTransform);


    }
    handleChangeCategory = event => {
        if (event.target.value == 'all') {
            selectedIndex = 0
        } else {
            selectedIndex = event.target.value
        }

        console.log("asdasgdvahgsvchavsc:::::::::::::", event.target.value)
        this.setState({
            [event.target.name]: event.target.value,
            mastercategory_id: event.target.value
        }, () => { this.handleChangeSubCategory(selectedIndex) });
    };
    resetTransform() {
        var windowScrollTop = window.pageYOffset / 3;
        this.setState({
            transform: 'translate3d(0,' + windowScrollTop + 'px,0)'
        });
    }

    renderLoading = index => {
        return (
            <div style={{ width: '1000', height: '400px' }} key={index}>
                <ContentLoader
                    width={1000}
                    height={400}
                    speed={2}
                    primaryColor="#dbd9d9"
                    secondaryColor="#dddddd"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="1000" height="400" />
                </ContentLoader>
            </div>
        );
    };
    getSelectedService = service => {
        if (typeof service != 'undefined') {
            this.setState({ keyword: service.heading, serviceId: service.key });
        }
    };
    searchClicked = () => {
        this.setState({
            searchLoader: true,
        })
        if (this.props.settings.constants.serviceAssignment == "user") {

            console.log("Inside if::::::::")

            this.props.history.push({
                pathname: `/provider/list/${this.state.keyword ? this.state.keyword : 'none'
                    }/${this.state.city ? this.state.city : 'none'}/${this.state.category ? this.state.category : 'none'
                    }`
            });
        } else {
            this.getMainSearchData(this.state.catIndex);
        }
    };




    handleClose = () => {
        selectedIndex = 0
        this.setState({
            showModal: false,
            showBookButton: false,
            categoryData: [],
            newcategoryServiceData: []
        })
    }



    openServicesDialog = (service, index) => {


        console.log("ff", service, service.mastercategory, service.mastercategory.name, service.name)

        this.state.headingTitle = service.mastercategory ? service.mastercategory.name : service.name;

        if (service.length == 0) {

            this.setState({
                showServiceDialog: true,
                showModal: false,
                serviceData: index
            })
        } else {
            serviceData = service.services;
            var tasksArray = service.services.map(taskItem => {
                taskItem.qty = 0
                return taskItem
            })
            this.setState({
                showServiceDialog: true,
                showModal: false,
                serviceData: tasksArray
            }, () => {
                console.log("POPUP ggtask::::::::::::::::::::", service)
            })
        }


    }

    handleCloseServiceDialog = () => {
        selectedIndex = 0
        addedTask = null
        this.setState({
            showServiceDialog: false,
            showBookButton: false
        })
    }
    handleCloseLoginModal = () => {
        this.setState({
            showLoginModal: false,
            password: "",
            passwordError: "",
            phone: "",
            hideLogin: true,
            hideGetOtp: false,
            is_otp: true,
            loaderButton: false,
            showBookButton: false
        })
    }
    handleCloseSignUpModal = () => {
        this.setState({
            showSignUpModal: false,
            showBookButton: false
        })
    }
    /* Adarsh's code end */

    handleSelectPlace = event => {
        console.log({ event });
        if (event) {
            this.setState({ city: event.gmaps.vicinity });
            cookies.set('latitude', event.location.lat, { path: '/' });
            cookies.set('longitude', event.location.lng, { path: '/' });
        } else {
            this.setState({ city: "" });
        }
    };

    onBookNow = () => {
        console.log("onBookNow:::::", this.props.userData)
        const bookingPopupOption = this.props.userData.name ? true : false;

        if (bookingPopupOption) {
            addedTask = null;
            if (this.state.serviceData.length < 0) {
                NotificationManager.error(
                    "You haven't add any service",
                    'Oops!'
                );
            } else {
                this.props.history.push({
                    pathname: `/book/service/2912adarsh1245`,
                    state: { serviceDataSource: this.state.serviceData }
                });
            }


        } else {
            console.log("Service ID AND Type::::", this.state.selectedServiceId, this.state.service_type)
            this.setState({
                showLoginModal: true,
                showServiceDialog: false,
            })

        }
    };

    renderLoginButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button className="custom-button"
                    onClick={() => this.proceedCall()}
                >
                    <FormattedMessage id="proceed" defaultMessage="Proceed" />
                </button>
            );
        }
    };

    renderSubmitButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button className="custom-button"
                    onClick={() => this.referVerify()}
                >
                    Submit
                </button>
            );
        }
    };

    referVerify = () => {
        if (this.state.reffer == "") {
            this.signupActionCall()
        } else {
            axios({
                method: 'get',
                url: `${SERVER_URL}/promocodes/check-referral?code=${this.state.reffer}`,
            }).then(resJson => {
                if (resJson.data.status == "OK") {
                    this.signupActionCall()
                }
                else if (resJson.data.status == "NOK") {
                    this.setState({
                        refferError: resJson.data.message
                    })
                }
            })
        }
    }

    signupActionCall = () => {
        if (this.state.email == "") {
            NotificationManager.error(
                "Email field required!",
                'Oops!'
            );
        } else if (this.state.name == "") {
            NotificationManager.error(
                "please enter name",
                'Oops!'
            );
        } else {

            this.setState({ loaderButton: true });
            this.props.signupAction(
                {
                    name: this.state.name,
                    email: this.state.email,
                    otp: this.state.password,
                    phone: this.state.phone,
                    countryCode: this.state.countryCode,
                    playerId: window.onesignalId,
                    referral_code: this.state.reffer,
                    role: ROLE_CUSTOMER
                },
                this.onSignUpDone
            );
        }
    };

    onSignUpDone = (success, data) => {
        if (success) {
            cookies.set('x-auth-token', data.token, { path: '/' });
            this.props.history.push({
                pathname: `/book/service/2912adarsh1245/`,
                state: { serviceDataSource: this.state.serviceData }

            });
            this.setState({
                loaderButton: false,
                showSignUpModal: false
            });
        } else {
            this.setState({
                loaderButton: false,
            });
            NotificationManager.error("Oops!", data.message)
        }

    }


    renderGetOtpButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <button
                    className="custom-button"
                    onClick={() => this.getOptCall()}
                >
                    Get OTP
                </button>
            );
        }
    };

    getOptCall = () => {
        if (this.state.accountType == "") {
            this.setState({
                typeError: "Choose account type!"
            })
        } else {
            if (this.state.phone.length != 10 & this.state.phone.length != 0) {
                this.setState({
                    phoneError: "phone length should be 10 *"
                })
            } else {
                this.setState({ loaderButton: true, timer: 60, showChangePhone: true });
                axios({
                    method: 'post',
                    url: `${SERVER_URL}/otp/generate`,
                    data: {
                        country_code: this.state.countryCode,
                        phone: this.state.phone,
                        role: this.state.accountType //need to remove it 
                    },
                }).then(resJson => {
                    /* console.log("Adahvs a s a sjhasca:::", resJson) */
                    if (resJson.data.status == "OK") {
                        NotificationManager.success("Success", resJson.data.message)
                        this.time = setInterval(() => {
                            this.setState((prevState => ({
                                timer: prevState.timer - 1
                            })))
                        }, 1000)
                        this.setState({
                            loaderButton: false,
                            hideLogin: false,
                            hideGetOtp: true,
                            showVerifyBtn: true,
                            password: ""
                        })
                    } else {
                        NotificationManager.error("Oops!", resJson.data.message)
                        this.setState({
                            loaderButton: false,
                            password: "",
                            showChangePhone: false,
                        })
                    }
                })
            }
        }

    }

    proceedCall = () => {
        this.setState({ loaderButton: true });
        axios({
            method: 'post',
            url: `${SERVER_URL}/otp/cverify`,
            data: {
                phone: this.state.phone,
                otp: this.state.password,
                playerId: window.onesignalId
            },
        }).then(resJson => {
            /* console.log("Adahvs a s a sjhasca:::", resJson) */
            if (resJson.data.status == "OK") {
                this.setState({
                    loaderButton: false,
                })
                if (resJson.data.data.existing_user) {
                    cookies.set('x-auth-token', resJson.data.data.token, { path: '/' });
                    this.props.history.push({
                        pathname: `/book/service/2912adarsh1245/`,
                        state: { serviceDataSource: this.state.serviceData }

                    });
                } else {
                    this.setState({
                        showSignUpModal: true,
                        showLoginModal: false
                    })
                }

            } else {
                NotificationManager.error("Oops!", resJson.data.message)
                this.setState({
                    loaderButton: false,
                    password: "",
                })
            }
        })
    };

    onDone = (success, data) => {
        NotificationManager.success("Success")
    }

    addServices = (index, serviceId, service_type) => {
        this.setState({
            selectedServiceId: serviceId,
            service_type: service_type
        }, () => { this.onBookNow() })
    }
    openNewServiceSuggestionDialog = () => {

        const bookingPopupOption = this.props.userData.name ? true : false;
        if (bookingPopupOption) {
            this.setState({
                newServiceDialog: true
            })
        } else {
            NotificationManager.error("Oops! please login to add suggestion")
        }

    }
    handleCloseSuggestionDialog = () => {
        this.setState({
            newServiceDialog: false,
            showSuggestionButton: false,
            showBookButton: false
        })
    }

    increaseQty(item, index) {
        console.log("Itemmmmmm :::", item)
        item.service_type == "Package" && "Hourly" ? item.qty += 1 : item.qty += 1;
        let updatedTask = [...this.state.serviceData];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceData: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceData: updatedTask, showBookButton: false });
        }
    }


    decreaseQty(item, index) {
        item.qty -= 1;
        let updatedTask = [...this.state.serviceData];
        updatedTask[index] = item;
        const checkServiceData = updatedTask.filter(singleItem => singleItem.qty > 0);
        if (checkServiceData.length > 0) {
            this.setState({ serviceData: updatedTask, showBookButton: true });
        } else {
            this.setState({ serviceData: updatedTask, showBookButton: false });
        }
    }
    render() {
        const { children, banners } = this.props;
        const { phoneError, error, passwordError, hideLogin, loaderButton, nameError,
            name, email, emailError, reffer, refferError } = this.state
        const { formatMessage } = this.props.intl;



        return (
            <div>
                <div className="homeslider-main">
                    {loading ? (
                        this.renderLoading(0)
                    ) : (
                        <div key={0}>
                            <div className="container">
                                <div className="align-items-center text-center justify-items-center h-100">
                                    <div className="col-12 height-auto" style={{ width: "100%" }}>
                                        <div className="responsive-text" style={{
                                            position: "absolute", top: 80, height: 100, padding: 20,
                                            width: "100%"
                                        }}>
                                            <p className="responsive-p1">The Easiest Way to Directly Book Contractors</p>
                                            <hr className="line"></hr>
                                            <span className="responsive-span1">We Only Work With the Best Pros</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="responsive-bg-header-div" style={{
                                    position: "absolute", width: "100%", height: 250, top: 0, left: 0, right: 0,
                                    zIndex: -1
                                }}>
                                    <img
                                        style={{ objectFit: "fill" }}
                                        className="full-width"
                                        width={'100%'}
                                        height={'100%'}
                                        aria-label="banner-img"
                                        src={require("../../assets/images/rectangle1.jpg")}
                                    />
                                </div>

                            </div>


                        </div>
                    )}
                </div>

                <Dialog
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.showModal}
                    fullWidth={true}
                    style={{ minHeight: "60%", height: '100%' }}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    onClose={this.handleClose}>
                    <div className="md-12 d-flex pr-2" style={{ height: 50, backgroundColor: "#3e78ff", justifyContent: "flex-end", alignItems: "center" }}>
                        <Clear onClick={() => {
                            this.handleClose()
                        }} />
                    </div>
                    {this.state.noDataMessage == "No category found" ?
                        <div className="service-modal-li mt-2">
                            <div className="row align-items-center">
                                <div className="col-md-12 text-left modal-list">
                                    <h4>So sorry, this service is not available in your area yet, but check back soon.</h4>
                                </div>
                            </div>
                        </div> : null
                    }
                    {this.state.noDataMessage != "No category found" ?
                        <div
                            style={{
                                width: "100%",
                                height: "100%",
                                flexDirection: "row",
                                display: "inline-flex",
                            }}>


                            <div style={{ width: "95%", backgroundColor: "#f4f4f4", height: "100%" }}>
                                {this.state.categoryData.length > 0 && this.state.categoryData.map((n, index) => {

                                    return (

                                        <div style={{ display: "flex" }} className="service-modal-li">
                                            <img className="responsive-service-img" style={{
                                                verticalAlign: "middle", borderStyle: "none",
                                                width: 100, height: 100, borderRadius: 150, marginLeft: 0, marginRight: 50
                                            }}
                                                src={n
                                                    .image
                                                    .medium}
                                                alt={
                                                    n.heading
                                                } />
                                            <div className="row align-items-center">
                                                <div className="col-md-12 text-left modal-list d-flex justify-content-between">
                                                    <h4 className="d-flex align-self-center">{n.heading}</h4>
                                                    <button id={'select_' + n.key}
                                                        style={{
                                                            bottom: 10, justifyContent: "center",
                                                            backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                                                            color: "#ffffff", borderWidth: 0,
                                                        }}
                                                    >Select</button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>

                        </div> : null
                    }
                    {this.state.noDataMessage == "No category found" ?
                        <div className="md-12 justify-content-center d-flex custom-min-h mb-5">
                            <button type="button" className="custom-button"
                                onClick={() => {
                                    this.openNewServiceSuggestionDialog()
                                }}>NEW SERVICE SUGGESTION</button>
                        </div> : null
                    }
                </Dialog>

                <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal"
                    open={this.state.showServiceDialog}
                    onClose={this.handleCloseServiceDialog}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="modal-header dir-pop-head">
                        <div className="heding1">
                            <h4 style={{ alignSelf: "center" }}>What Would You Like To Do With {this.state.headingTitle} Service</h4>

                        </div>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseServiceDialog()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            {this.state.serviceData.length > 0 && this.state.serviceData.map((item, index) => {

                                return (

                                    <div className="service-modal-li">
                                        <div className="row align-items-center" >
                                            <div className="col-md-8 text-left modal-list">
                                                <h4>{item.heading}</h4>
                                                <p>{item.description}</p>
                                                <p>{item.service_type}</p>
                                                {item.service_type != "Hourly" ? <p className="color_text">${item.price}</p> : <p>{item.price}/hr</p>}

                                            </div>
                                            <div className="col-md-4 text-right d-flex" style={{ flexDirection: "row", borderRadius: 3 }}>


                                                {item.qty == 0 ?
                                                    <div className="col-md-12 d-flex" style={{ flexDirection: "row" }}>
                                                        <div className="col-md-8 justify-content-center d-flex">
                                                        </div>
                                                        <div className="col-md-4 justify-content-center addplus d-flex" onClick={() => this.increaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Add style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                    </div> :

                                                    <div className="col-md-12 d-flex align-items-center" style={{ flexDirection: "row" }}>
                                                        <div className="col-md-4 justify-content-center addplus d-flex" onClick={() => this.decreaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Remove style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                        <div className="col-md-4 justify-content-center d-flex">
                                                            <p style={{ alignSelf: "center" }}>{item.qty}</p>
                                                        </div>
                                                        <div className="col-md-4 justify-content-center addplus d-flex" onClick={() => this.increaseQty(item, index)}
                                                            style={{ backgroundColor: this.props.colors.SECONDARY.HEX }}>
                                                            <Add style={{ alignSelf: "center", color: "white" }} />
                                                        </div>
                                                    </div>}

                                            </div>

                                        </div>
                                    </div>
                                )
                            })}
                            {this.state.serviceData.length == 0 ?
                                <div className="service-modal-li">
                                    <div className="row align-items-center">
                                        <div className="col-md-12  text-center modal-list">
                                            <h4>No service availabe in this category</h4>

                                        </div>
                                    </div>
                                </div> : null

                            }

                            {this.state.serviceData.length == 0 && this.state.showSuggestionButton &&
                                <div className="col-md-12 mb-5 justify-content-center d-flex">
                                    <button type="button" className="custom-button"
                                        onClick={() => {
                                            this.openNewServiceSuggestionDialog()
                                        }}>NEW SERVICE SUGGESTION</button>
                                </div>}

                        </DialogContent>
                    </div>


                    {this.state.showBookButton && <button style={{
                        alignSelf: 'center', display: "inline-flex",
                        position: "unset", bottom: 10, justifyContent: "center",
                        backgroundColor: this.props.colors.SECONDARY.HEX, padding: 15, borderRadius: 8,
                        color: "#ffffff", borderWidth: 0, width: "90%", marginBottom: 15
                    }}
                        disabled={this.state.showBookButton ? false : true}
                        onClick={this.onBookNow}
                    >BOOK NOW</button>}

                    {this.state.newServiceDialog &&
                        <NewServiceSuggestionDialog
                            closeDialog={this.handleCloseSuggestionDialog}
                        />}


                </Dialog>
                {this.state.newServiceDialog &&
                    <NewServiceSuggestionDialog
                        closeDialog={this.handleCloseSuggestionDialog}
                    />}


                {this.state.showLoginModal && <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="login-modal"
                    open={this.state.showLoginModal}
                    onClose={this.handleCloseLoginModal}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="md-12 pl-4 pr-1 verfitext"
                        style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%", background: this.props.colors.SECONDARY.HEX }}>
                        <h4 style={{ alignSelf: "center", color: "#ffffff" }}>Verify Mobile Number</h4>
                        <Clear className="close_icon" style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseLoginModal()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            <div className="log-in-pop-right">

                                <h4>Mobile Number</h4>

                                <form
                                    className="s12 ng-pristine ng-valid form-new"
                                    autoComplete="off"

                                >
                                    <div
                                        className="dialog-header"
                                        style={{
                                            backgroundColor: this.props.theme
                                                .palette.primary.main
                                        }}
                                    />
                                    <div className="dialog-body">
                                        <div className="row" style={{ marginTop: -20 }}>

                                            <div className="col-md-12 mb-2">
                                                <TextField
                                                    error={phoneError ? true : false}
                                                    helperText={phoneError}
                                                    className="login-form-textfield"
                                                    label="Mobile"
                                                    id="phone"
                                                    fullWidth={true}
                                                    name="mobile"
                                                    type="number"
                                                    value={this.state.phone}
                                                    onChange={e => {
                                                        const re = /^[0-9\b]+$/;
                                                        if (e.target.value === '' || re.test(e.target.value) && e.target.value.length <= 10) {
                                                            this.setState({
                                                                phone: e.target.value,
                                                                phoneError: "",
                                                                error: ""
                                                            })
                                                        }
                                                    }}
                                                    disabled={this.state.loaderButton || this.state.hideGetOtp}
                                                    margin="normal"
                                                />

                                                {this.state.showChangePhone && (
                                                    <a className="mb-2" style={{ justifyContent: "flex-end", display: "flex" }} href="javascript:void(0);">
                                                        <p onClick={() => {
                                                            this.setState({
                                                                hideGetOtp: false,
                                                                hideLogin: true,
                                                                showChangePhone: false,
                                                                timer: 0
                                                            })
                                                        }}>
                                                            Change mobile number
                                                        </p>
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                        {!this.state.hideGetOtp &&
                                            <div className="d-flex justify-content-center md-12">
                                                {this.renderGetOtpButton()}
                                            </div>}
                                        {this.state.hideGetOtp &&
                                            <div className="input-field s12" style={{ marginTop: -20, display: "flex", flexDirection: "column" }}>
                                                <TextField
                                                    error={passwordError ? true : false}
                                                    helperText={passwordError}
                                                    className="login-form-textfield"
                                                    id="password"
                                                    fullWidth={true}
                                                    type="number"
                                                    name="OTP"
                                                    label={"One Time Password"}
                                                    value={this.state.password}
                                                    onChange={event => {
                                                        if (event.target.value.length <= 8) {
                                                            this.setState({
                                                                password:
                                                                    event.target.value,
                                                                passwordError: ''
                                                            });
                                                        }
                                                    }}
                                                    disabled={this.state.loaderButton}
                                                    margin={'normal'}
                                                />
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "end"
                                                    }}
                                                    className="input-field s12">
                                                    {!this.state.timer == 0 ? <a href="javascript:void(0);">
                                                        <p >
                                                            Resend otp 0:{this.state.timer}
                                                        </p>
                                                    </a> : <a href="javascript:void(0);">
                                                        <p onClick={() => {
                                                            this.getOptCall()
                                                        }}>
                                                            Resend
                                                        </p>
                                                    </a>}

                                                </div>
                                            </div>}

                                        {!hideLogin && <div className="sign-new-btn text-left d-flex justify-content-center">
                                            {this.renderLoginButton()}
                                        </div>}
                                    </div>
                                </form>
                            </div>


                        </DialogContent>
                    </div>


                </Dialog>}
                {this.state.showSignUpModal && <Dialog
                    fullWidth={true}
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="login-modal"
                    open={this.state.showSignUpModal}
                    onClose={this.handleCloseSignUpModal}
                    aria-labelledby="form-dialog-title"
                >

                    <div className="md-12 pl-2 pr-2"
                        style={{ height: 60, display: "flex", justifyContent: "space-between", width: "100%", background: this.props.colors.SECONDARY.HEX }}>
                        <h4 style={{ alignSelf: "center", color: "#ffffff" }}>Provide Additional Info</h4>
                        <Clear style={{ alignSelf: "center", color: "#ffffff" }} onClick={() => {
                            this.handleCloseSignUpModal()
                        }} />

                    </div>

                    <div>
                        <DialogContent>
                            <div className="log-in-pop-right">
                                <a
                                    href="#"
                                    className="pop-close"
                                    data-dismiss="modal"
                                />
                                <form
                                    className="s12 ng-pristine ng-valid form-new"
                                    autoComplete="off"

                                >
                                    <div
                                        className="dialog-header"
                                        style={{
                                            backgroundColor: this.props.theme
                                                .palette.primary.main
                                        }}
                                    />
                                    <div className="dialog-body">
                                        <div className="row" style={{ marginTop: -20 }}>

                                            <div className="col-md-12 mb-2">
                                                <TextField
                                                    error={nameError ? true : false}
                                                    helperText={nameError}
                                                    className="login-form-textfield"
                                                    label={formatMessage({
                                                        id: 'name'
                                                    })}
                                                    id="name"
                                                    fullWidth={true}
                                                    name="name"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={event => {
                                                        this.setState({
                                                            name: event.target.value,
                                                            nameError: ''
                                                        });
                                                    }}
                                                    disabled={loaderButton}
                                                    margin="normal"
                                                />
                                            </div>
                                        </div>

                                        <div className="input-field s12" style={{ marginTop: -20 }}>
                                            <TextField
                                                error={emailError ? true : false}
                                                helperText={emailError}
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'email'
                                                })}
                                                id="email"
                                                fullWidth={true}
                                                name="email"
                                                type="email"
                                                value={this.state.email}
                                                onChange={event => {
                                                    this.setState({
                                                        email: event.target.value,
                                                        emailError: ''
                                                    });
                                                }}
                                                disabled={loaderButton}
                                                margin="normal"
                                            />
                                        </div>
                                        <div className="input-field s12" style={{ marginTop: -13 }}>

                                            <TextField
                                                error={refferError ? true : false}
                                                helperText={refferError}
                                                className="login-form-textfield"
                                                label={formatMessage({
                                                    id: 'enterReffer'
                                                })}
                                                id="reffercode"
                                                fullWidth={true}
                                                name="Reffer Code"
                                                type="text"
                                                value={this.state.reffer}
                                                onChange={event => {
                                                    this.setState({
                                                        reffer: event.target.value,
                                                        refferError: ''
                                                    });
                                                }}
                                                disabled={loaderButton}
                                                margin="normal"
                                            />
                                        </div>

                                        <div className="sign-new-btn text-left d-flex justify-content-center">
                                            {this.renderSubmitButton()}
                                        </div>
                                    </div>
                                </form>
                            </div>


                        </DialogContent>
                    </div>


                </Dialog>}
            </div>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData,
        colors: settings.colors
    };
};
const composedComponent = compose(
    withTheme(),
    connect(mapStateToProps, actions)
);

export default composedComponent(withRouter(injectIntl(
    GoogleApiWrapper(props => ({
        apiKey: GOOGLE_MAP_KEY
    }))(HomeCaroselParallax)))
);



// WEBPACK FOOTER //
// ./src/components/Parallax/HomeCaroselParallax.jsx